/*
 *
 * LanguageToggle
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import Wrapper from './Wrapper';
import {makeSelectLocale} from '../LanguageProvider/selectors';
import ToggleOption from '../ToggleOption';
import messages from './messages';
import {changeLocale} from "../LanguageProvider/actions";


export class LocaleToggle extends React.PureComponent {


    constructor(props, context) {
        super(props, context);
    }

    render() {

        const langOptions = [
            {key: 1, text: 'Indonesia', value: 'id'},
            {key: 2, text: 'English', value: 'en'}
        ];


        return (
            <Wrapper>
                <ToggleOption options={langOptions}
                              inputLabel={messages[this.props.locale]}
                              onClickItem={this.props.onLocaleToggle}/>
            </Wrapper>
        );
    }
}

LocaleToggle.propTypes = {
    onLocaleToggle: PropTypes.func,
    locale: PropTypes.string,
};

const mapStateToProps = createSelector(makeSelectLocale(), locale => ({
    locale,
}));


export function mapDispatchToProps(dispatch) {
    return {
        onLocaleToggle: (evt, data) => {
            dispatch(changeLocale(data.value));
            window.scrollTo(0, 0);
        },
        dispatch,
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LocaleToggle);



// WEBPACK FOOTER //
// ./src/components/LocaleToggle/index.js